//httpConfig.interceptor.ts
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EoHttpConfigInterceptor implements HttpInterceptor {
  token?: string | null;

  constructor(
    @Inject('apiUrl') private readonly apiUrl: string,
    @Inject('apiAppVersion') private readonly apiAppVersion: string,
    @Inject('appName') private readonly appName: string
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!request.url.includes(`${this.apiUrl}/v1`)) {
      return next.handle(request);
    }

    request = request.clone({
      setHeaders: { AppVersion: this.apiAppVersion },
    });

    let state = JSON.parse(localStorage.getItem(this.appName) ?? '{}');
    this.token = state?.token?.access_token;
    //this.token = state?.auth?.authData?.access_token; // probable inject it in the future

    if (this.token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${this.token}` },
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      })
    );
  }
}
